import { Divider, Form, message } from "antd";
import { Dispatch, SetStateAction, useState } from "react";
import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import LocationMap from "../Location";
import NumberNameEmail from "../NumberNameEmail";

import { IoIosArrowBack } from "react-icons/io";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { updateStep3 } from "../../../services/store/slices/onboarding";

type Props = {
  nextStep: () => void;
  data: any;
  updateData: Dispatch<SetStateAction<{ name: string; email: string }>>;
};

const Step3 = ({ nextStep }: Props) => {
  const dispatch = useDispatch();
  const step = useSelector((state: any) => state?.SalonProfile?.step3);
  const { name, phone, email, business_location } = step;
  const [newLatLng, setNewLatLng] = useState<any>({
    lat: 24.774265,
    lng: 46.738586,
  });
  const [mapInfo, setMapInfo] = useState("");
  const [value, setValue] = useState(phone || 0);
  const onFinish = (values: any) => {
    if (!isValidPhoneNumber(value)) {
      message.error("inValidPhone");
      return;
    }
    const phoneNumber = parsePhoneNumber(value || "");
    const salonData = {
      contact_country_code: phoneNumber ? phoneNumber?.country : "",
      contact_number: phoneNumber ? phoneNumber?.nationalNumber : "",
    };
    values.lat = newLatLng.lat;
    values.lng = newLatLng.lng;
    values.business_location.Address = mapInfo;
    dispatch(updateStep3({ ...values, ...salonData }));
    console.log(values);
    nextStep();
  };
  const [form] = Form.useForm();

  return (
    <Form
      className="w-full"
      name="step3"
      onFinish={onFinish}
      layout={"vertical"}
      form={form}
      initialValues={{
        name: {
          ar: name?.ar || "",
          en: name?.en || "",
        },
        phone: phone || "",
        email: email || "",
        business_location: {
          Building: business_location?.Building || "",
          streetName: business_location?.streetName || "",
          District: business_location?.District || "",
          City: business_location?.City || "",
          Country: business_location?.Country || "",
          main: business_location?.main || "",
        },
      }}
    >
      <div className="text-[#75757E] py-4 text-lg max-lg:text-base font-normal flex flex-col gap-5 max-lg:gap-2 w-full items-center justify-center text-center my-8 max-lg:mb-3 mt-4">
        <span>
          <FormattedMessage
            id="INTL.FORM.make_experience_more_personalized"
            defaultMessage="Let us make your experience more personalized for you and your clients!"
          />
        </span>
        <span>
          <FormattedMessage
            id="INTL.FORM.complete_following_information_about_your_workplace"
            defaultMessage="Complete the following information about your workplace"
          />
        </span>
      </div>
      <NumberNameEmail value={value} setValue={setValue} />
      <Divider className="max-md:!my-3 max-md:!mb-5" />
      <LocationMap
        fo={form}
        newLatLng={newLatLng}
        setNewLatLng={setNewLatLng}
        mapInfo={mapInfo}
        setMapInfo={setMapInfo}
      />
      <Form.Item className="w-full flex justify-center items-center mt-8 !mb-0">
        <button
          type="submit"
          className="rounded-full border-solid border-color-primary border-t-2 border-b-2 border-r-2 items-center justify-center rotate-45 border-l-2 border-l-white cursor-pointer bg-[#EEF0FF] w-14 h-14"
        >
          <IoIosArrowBack className="w-5 h-5 mt-1 -rotate-45 text-color-primary" />
        </button>
      </Form.Item>
    </Form>
  );
};

export default Step3;
